import Player from '@vimeo/player';
import Swiper, { EffectFade, Navigation, Pagination } from 'swiper';

import { loop } from '/src/scripts/utils/common';
import { makePopup } from '/src/scripts/es-modules/popup';

function makeGallery(videos, vertical) {
  let popup,
    swiper,
    players = [];

  const hasManyVideo = videos.length > 1;

  popup = makePopup({
    content: printSlider(videos, vertical),
    cssClass: ['video-popup'],
    onClose: () => {
      if (hasManyVideo) {
        swiper.destroy();
      }

      popup.destroy();
    },
  });

  if (hasManyVideo) {
    swiper = new Swiper('.video-gallery', {
      on: {
        transitionStart: () => {
          for (let i = 0; i < players.length; i += 1) {
            const player = players[i];

            player.pause();
            player.setCurrentTime(0);
          }
        },
      },
      modules: [EffectFade, Navigation],
      navigation: {
        prevEl: '.video-gallery__arrow_prev',
        nextEl: '.video-gallery__arrow_next',
      },
    });
  }

  loop('.video-gallery__src', (elm) => {
    players.push(new Player(elm));
  });

  popup.open();
  players[0].play();
}

function printSlider(videos, vertical) {
  const variant = vertical ? 'vertical' : '';
  const hasManyVideo = videos.length > 1;

  const printSlides = (videos) => {
    return videos.reduce(
      (res, { id, head, foot }) => `${res}
        <div class="video-gallery__slide swiper-slide">
          <div class="video-gallery__view">
            <iframe
              src="https://player.vimeo.com/video/${id}"
              class="video-gallery__src"
              allow="autoplay; fullscreen"></iframe>
            ${
              hasManyVideo
                ? `
                  <button class="video-gallery__arrow video-gallery__arrow_prev"></button>
                  <button class="video-gallery__arrow video-gallery__arrow_next"></button>
                `
                : ''
            }
          </div>
          ${head ? `<div class="video-gallery__text">${head}</div>` : ''}
          ${foot ? `<div class="video-gallery__text">${foot}</div>` : ''}
        </div>
      `,
      '',
    );
  };

  return `
    <div class="video-gallery video-gallery_${variant} swiper">
      <div class="video-gallery__track swiper-wrapper">
        ${printSlides(videos)}
      </div>
    </div>
  `;
}

loop('.video-carousel', (box) => {
  const data = JSON.parse(
    document.getElementById(box.dataset.dataId).textContent,
  );

  const show = box.querySelector('.video-carousel__swiper');
  const isVertical = box.classList.contains('video-carousel_v');

  new Swiper(show, {
    loop: true,
    speed: 600,
    grabCursor: true,
    spaceBetween: 0,
    slidesPerView: 'auto',
    centeredSlides: true,
    slideToClickedSlide: true,
    watchSlidesProgress: true,
    preventInteractionOnTransition: true,
    modules: [Navigation, Pagination],
    pagination: {
      el: box.querySelector('.video-carousel__pages'),
      clickable: true,
    },
    navigation: {
      prevEl: box.querySelector('.video-carousel__arrow_prev'),
      nextEl: box.querySelector('.video-carousel__arrow_next'),
    },
    breakpoints: {
      768: {
        spaceBetween: 40,
      },
    },
  });

  box.addEventListener('click', (e) => {
    const el = e.target;
    if (el.closest('.video-carousel__item')) {
      const videos = data[el.dataset.index];

      if (videos.length) {
        makeGallery(videos, isVertical);
      }
    }
  });
});
